import React from 'react';
import { observer } from 'mobx-react';

import SignIn from './SignIn';
import About from './About';

import { pageTitle } from './util/Style';

function Login(props) {
    return (
        <div style={{ marginRight: 5, marginLeft: 5 }}>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", textAlign: "center", alignItems: "center", background: "#fafafa" }}>
                <div style={{ width: "50%", textAlign: "center" }}>
                    {pageTitle("Connecting People with Product")}
                </div>
                <div style={{ width: "50%", textAlign: "left" }}>
                    <SignIn appStore={props.appStore} />
                </div>
            </div>
            <About />
        </div>
    );
}
export default observer(Login)